import { all, call, put, takeLatest } from 'redux-saga/effects'
import { api } from 'network/api'
import { getFAQsKey } from 'utils/appUtils'
import { getItemIfHashCodeMatches, setItem } from 'utils/storageUtils'
import { helpUrl } from './urls'
import { actions, getHelpDataSuccess, getHelpDataFailed } from './actions'

const faqsBaseParams = {
    app: '7now_faq',
    version: '1',
}

//= ============================================================================================================

function* fetchHelpDetails(action) {
    try {
        const { language } = action.payload
        const key = getFAQsKey()
        const storageObj = getItemIfHashCodeMatches(key)
        let response = storageObj.item
        if (!response) {
            const url = `${helpUrl}?app=${faqsBaseParams.app}&version=${faqsBaseParams.version}`
            response = yield call(api, url, 'GET', null, 0, null, false, language)
            setItem(key, response, storageObj.hashCode)
        }
        yield put(getHelpDataSuccess(response))
    } catch (error) {
        yield put(getHelpDataFailed())
    }
}

//= ============================================================================================================

function* getHelpDetailsWatcher() {
    yield takeLatest(actions.GET_HELP_DATA, fetchHelpDetails)
}

export default function* helpDetailsSaga() {
    yield all([getHelpDetailsWatcher()])
}
